import axios from 'axios';

//const API_URL = 'https://localhost:7031/api'; 
const API_URL = 'https://521xjb6dh4.execute-api.ap-southeast-1.amazonaws.com/dev/api';


// Function to get the auth token from localStorage
const getToken = () => localStorage.getItem('token');

// Axios instance with default headers
const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor to add token to headers
api.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// API calls
export const fetchAdminData = () => api.get('/users/admin');
export const fetchUserData = () => api.get('/users/user');
export const changePassword = (oldPassword, newPassword) =>
    api.post('/users/change-password', { oldPassword, newPassword });
export const getInfluencersList = () => api.get('/InfluencerData/influencers');
export const updateInfluencerDetails = (influencer) => api.put('/InfluencerData/update-influencer', influencer);
export const getProfileDetails = (influencerId, platformAccountType) => api.get(`/InfluencerData/${influencerId}/${platformAccountType}`);
export const getTopContent = (influencerId, platformAccountType) => api.get(`/InfluencerData/${influencerId}/${platformAccountType}/top-contents/images`);
export const getReputationHistory = (influencerId, platformAccountType) => api.get(`/InfluencerData/${influencerId}/${platformAccountType}/reputation-history`);
export const getAudienceData = (influencerId, platformAccountType) => api.get(`/InfluencerData/${influencerId}/${platformAccountType}/audience-data`);
export const getSimilarProfiles = (influencerId, platformAccountType) => api.get(`/InfluencerData/${influencerId}/${platformAccountType}/similar-profiles`);
export const getTopMentions = (influencerId, platformAccountType) => api.get(`/InfluencerData/${influencerId}/${platformAccountType}/top-mentions`);
export const getTopHashtags = (influencerId, platformAccountType) => api.get(`/InfluencerData/${influencerId}/${platformAccountType}/top-hashtags`);
export const getActivityLog = () => api.get(`/users/activities`);
export const logUserActivity = (activity) => api.post(`/users/log`, activity);
export const deleteInfluencer = (influencerId) => api.delete(`/InfluencerData/delete-influencer/${influencerId}`);
export const importCSVFile = (formData) => 
    api.post('/InfluencerData/import-influencers', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });

export const insertShortlist = (shortlist) => api.post('/InfluencerData/insert-shortlist', shortlist);
export const updateShortlist = (shortlist) => api.put('/InfluencerData/update-shortlist', shortlist);
export const deleteShortlist = (shortlistId) => api.delete(`/InfluencerData/delete-shortlist/${shortlistId}`);
export const getShortlists = () => api.get('/InfluencerData/get-shortlists');
export const getInfluencers = (queryString) => api.get(`/InfluencerData/GetInfluencers?${queryString}`);
export const getCampaigns = () => api.get('/Campaigns');
export const addCampaigns = (campaign) => api.post('/Campaigns', campaign);
export const getInfluencersByCampaignID = (campaignID) => api.get(`/Campaigns/getInfluencerByCampaignId/${campaignID}`);
export const addCampaignInfluencer = (data) => api.post('/Campaigns/insertInfluencersIdByCampaignId', data);
export const addContentForm = (contentForm) => api.post('/Campaigns/save-content', contentForm);
export const getPostDataByCampaignId = (campaignID, workplaceId = null, creator = null) => {
    const params = new URLSearchParams();

    if (workplaceId) params.append("workplaceId", workplaceId);
    if (creator) params.append("creator", creator);

    return api.get(`/Campaigns/getPostDataByCampaignId/${campaignID}?${params.toString()}`);
};

export const getAnalyzeDataByPostUrl = (postUrl) => {
    console.log("PostUrl", postUrl);
    return api.post('/Campaigns/getAnalyzeDataByPostUrl', { PostUrl: postUrl });
};
export const callOpenAIAPI = (prompt) => api.post('/OpenAI/generate', prompt);

